import React, {useEffect, useMemo, useState} from 'react';
import {get} from '../../../api';
import {FormattedMessage} from 'react-intl';
import uniq from 'lodash.uniq';
import CreativeItem from './CreativeItem';
import {connect} from 'react-redux';
import Skeleton from 'react-loading-skeleton'

function CreativesGrid(props) {
    const allowedCategories = useMemo(()=>{
        if(props.category){
            return props.category.split("\n").map((i)=>i.trim()).filter((i)=>i)
        }
        return null;
    },[props.category])


    const [creatives, setCreatives] = useState([])
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState(props.category)
    const [categories, setCategories] = useState([])

    useEffect(()=>{
        loadCreatives()
    },[])


    const loadCreatives = (category) => {
        setLoading(true)
        const q = category && {category};
        get('/creatives', q).then((data) => {
            let creatives = data.creatives || data;
            const categories = uniq(creatives.map(({media_category}) => media_category));
            setCreatives(creatives)
            if(allowedCategories){
                setCategories(categories.filter((item)=>allowedCategories.indexOf(item) > -1));
            }else {
                setCategories(categories);
            }
            setLoading(false)
            if(!props.category) {
                setCategory(creatives.length > 10 && categories.length > 0 ?
                    categories[0] :
                    '')
            }
        }).catch(() => {
            setLoading(false)
        });
    }
    const filteredCreatives = useMemo(()=>{
         return creatives && creatives.length > 0 ? creatives.filter(({media_category, media_id}) => {
             if (!category) {
                 return true;
             }
             return media_category === category;
         }) : []
     },[creatives, category])
    if(creatives.length === 0) return null
    return (
        <>
            <div
                className="d-flex justify-content-between align-items-center">
                {!props.category ?
                    <h3><FormattedMessage id={'mediaAssets'}/></h3> : null
                }
                {
                    categories.length > 0 && <div className="d-flex my-2">
                        <select className="form-control" value={category}
                                onChange={(e) => setCategory(
                                    e.target.value)}>
                            {
                                creatives.length < 100 ?
                                    <FormattedMessage
                                        id={"Show all"}>{text => <option
                                        value="">{text}</option>}</FormattedMessage> :
                                    null
                            }
                            {
                                categories.map((item) => <option key={item}
                                                                 value={item}>{item}</option>)
                            }
                            {
                                creatives.length >= 100 ?
                                    <FormattedMessage
                                        id={"Show all"}>{text => <option
                                        value="">{text}</option>}</FormattedMessage> :
                                    null
                            }
                        </select>
                    </div>
                }
            </div>
            {
                loading && <div className={"card-columns"}>
                <div className="card">
                    <Skeleton height={200} />
                </div>
                    <div className="card">
                        <Skeleton height={200} />
                    </div>
                    <div className="card">
                        <Skeleton height={200} />
                    </div>
                </div>
            }
            <div className="d-flex"/>
            <div className={'card-columns'}>
                {
                    filteredCreatives.map((item)=>{
                       return  <CreativeItem
                            key={String(item.media_id)}
                            {...item}
                        />
                    })
                }
            </div>
        </>
    );
}

function mapStateToProps(state) {
    return {
        aff_file_upload: state.settings.aff_file_upload
    }
}

export default connect(mapStateToProps)(CreativesGrid)
